export const slug = "profile";
export const title = "My Profile";
export const section = "Administration";
export const content = `
# My Profile

The Profile page lets you update your own account information.

## Updating Personal Info

- **Display Name** — the name shown in the audit log and next to your actions.
- **Email Address** — used for login and system notifications. Changing your email requires a verification step.

Click **Save Changes** after editing.

## Changing Your Password

1. Click **Change Password**.
2. Enter your current password to confirm your identity.
3. Enter and confirm your new password (minimum 8 characters).
4. Click **Update Password**.

You will remain logged in after the change. Other sessions will be signed out.

## Notification Preferences

Choose which system events send you an email notification:

- Pending approvals waiting for review
- New self-service invite requests
- Bounce and spam alerts for client emails
- Daily Saturday summary report

## Tips

- If you have forgotten your current password, log out and use the **Forgot Password** link on the login page.
- Profile changes are logged in the audit log so admins can track account modifications.
`;
